import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FeedbackDetailAPICallProps, ReceivedFeedbackDetailData } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const receivedFeedbackDetail = createAsyncThunk(
  "feedback/received/detail",
  async (params: FeedbackDetailAPICallProps, storeActions) => {
    const url = `api/v1/user/feedbacks/received/detail?feedbackId=${params.feedbackId}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        feedback: await response.json(),
      };
    }
    return {
      status: response.status,
      feedback: null,
    };
  }
);

const receivedFeedbackDetailSlice = createSlice({
  name: "receivedFeedbacks",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    feedback: null as ReceivedFeedbackDetailData | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.feedback = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      receivedFeedbackDetail.fulfilled,
      (
        state,
        {
          payload,
        }: PayloadAction<{
          status: number | null ;
          feedback: ReceivedFeedbackDetailData | null;
        }>
      ) => {
        state.status = payload.status;
        state.loading = false;
        state.feedback = payload.feedback;
      }
    );
    builder.addCase(receivedFeedbackDetail.pending, (state) => {
      state.loading = true;
      state.status = null;
    });
    builder.addCase(receivedFeedbackDetail.rejected, (state) => {
      state.status = 503;
      state.loading = false;
    });
  },
});

export const { clearData } = receivedFeedbackDetailSlice.actions;

export default receivedFeedbackDetailSlice;
